/* eslint-disable */
import store from '@/store';
import { isHighChartsReady } from '@/utils/helpers';

export const waitForFirebaseInitialized = (appStore = store) => {
  return new Promise((resolve) => {
    const check = () => {
      if (appStore.state.app.firebaseInitialized) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

export const waitForStatusReady = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (typeof store.state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

export const waitForSignalrInitialized = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (store.state.app.signalrInitialized || !store.getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

export const waitForHighCharts = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (isHighChartsReady()) {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};
